// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MaterialOrderSummary Styles */
.MaterialOrderSummary-container {
  max-width: 1400px;
  /* margin: 0 auto;
  padding: 20px; */
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
}

/* Header */
.MaterialOrderSummary-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 30px 0;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Table */
.MaterialOrderSummary-table-container {
  overflow-x: auto;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.MaterialOrderSummary-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  min-width: 800px;
}

.MaterialOrderSummary-table-header {
  /* background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); */
  color: #374151;
  font-size: 13px;
  font-weight: 700;
  padding: 16px;
  text-align: left;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 10;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.MaterialOrderSummary-table-row {
  transition: all 0.2s ease;
}

.MaterialOrderSummary-table-row:hover {
  background-color: #f8fafc;
}

.MaterialOrderSummary-table-row:nth-child(even) {
  background-color: #fafbfc;
}

.MaterialOrderSummary-table-cell {
  padding: 16px;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

/* Actions */
.MaterialOrderSummary-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.MaterialOrderSummary-action-button {
  padding: 8px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.MaterialOrderSummary-edit-button {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.MaterialOrderSummary-edit-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);
}

.MaterialOrderSummary-delete-button {
  background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%);
  color: white;
}

.MaterialOrderSummary-delete-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.3);
}

/* Modal */
.MaterialOrderSummary-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.MaterialOrderSummary-modal {
  background: white;
  border-radius: 12px;
  padding: 30px;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.MaterialOrderSummary-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.MaterialOrderSummary-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.MaterialOrderSummary-close-button {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s ease;
}

.MaterialOrderSummary-close-button:hover {
  color: #ef4444;
}

/* Form */
.MaterialOrderSummary-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.MaterialOrderSummary-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.MaterialOrderSummary-form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.MaterialOrderSummary-form-input {
  padding: 12px 16px;
  font-size: 14px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  transition: all 0.3s ease;
  outline: none;
}

.MaterialOrderSummary-form-input:focus {
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.MaterialOrderSummary-form-error {
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
}

.MaterialOrderSummary-form-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
}

.MaterialOrderSummary-submit-button {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  padding: 12px 30px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.MaterialOrderSummary-submit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

.MaterialOrderSummary-cancel-button {
  background: #f1f5f9;
  color: #64748b;
  border: 2px solid #e2e8f0;
  padding: 12px 30px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.MaterialOrderSummary-cancel-button:hover {
  background: #e2e8f0;
  color: #475569;
}

/* No Data */
.MaterialOrderSummary-no-data {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  font-style: italic;
  font-size: 16px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .MaterialOrderSummary-container {
    padding: 15px;
  }
}

@media (max-width: 768px) {
  .MaterialOrderSummary-title {
    font-size: 2rem;
  }

  .MaterialOrderSummary-table {
    min-width: 600px;
  }

  .MaterialOrderSummary-form-actions {
    flex-direction: column;
  }

  .MaterialOrderSummary-submit-button,
  .MaterialOrderSummary-cancel-button {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .MaterialOrderSummary-container {
    padding: 10px;
  }

  .MaterialOrderSummary-table-header,
  .MaterialOrderSummary-table-cell {
    padding: 12px 8px;
    font-size: 12px;
  }

  .MaterialOrderSummary-action-button {
    padding: 6px;
  }
}

/* Print Styles */
@media print {
  .MaterialOrderSummary-container {
    background: white;
    box-shadow: none;
  }

  .MaterialOrderSummary-table-container {
    box-shadow: none;
    border: 1px solid #000;
  }

  .MaterialOrderSummary-table-header {
    background: #f0f0f0 !important;
    color: #000 !important;
  }

  .MaterialOrderSummary-action-button,
  .MaterialOrderSummary-modal-overlay {
    display: none;
  }
}

.MaterialOrderSummary-table-header-action {
  background: #ffffff !important;
  color: #000 !important;
  border-bottom: 2px solid #e2e8f0;
}
.MaterialOrderSummary_print_container {
  display: flex;
  justify-content: end;
}
.MaterialOrderSummary_print_container button {
  padding: 10px 30px;
  border-radius: 5px;
  border: none;
  outline: none;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #0d5787 0%, #91c8e4 100%);
  color: white;
  font-weight: 600;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Material/MaterilOrderSummery.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,iBAAiB;EACjB;kBACgB;EAChB;cACY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mEAAmE;EACnE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* MaterialOrderSummary Styles */\n.MaterialOrderSummary-container {\n  max-width: 1400px;\n  /* margin: 0 auto;\n  padding: 20px; */\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    sans-serif;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n/* Header */\n.MaterialOrderSummary-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0 0 30px 0;\n  text-align: center;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Table */\n.MaterialOrderSummary-table-container {\n  overflow-x: auto;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.MaterialOrderSummary-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  min-width: 800px;\n}\n\n.MaterialOrderSummary-table-header {\n  /* background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); */\n  color: #374151;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 16px;\n  text-align: left;\n  border-bottom: 2px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.MaterialOrderSummary-table-row {\n  transition: all 0.2s ease;\n}\n\n.MaterialOrderSummary-table-row:hover {\n  background-color: #f8fafc;\n}\n\n.MaterialOrderSummary-table-row:nth-child(even) {\n  background-color: #fafbfc;\n}\n\n.MaterialOrderSummary-table-cell {\n  padding: 16px;\n  font-size: 14px;\n  color: #374151;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n\n/* Actions */\n.MaterialOrderSummary-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n.MaterialOrderSummary-action-button {\n  padding: 8px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.MaterialOrderSummary-edit-button {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n}\n\n.MaterialOrderSummary-edit-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);\n}\n\n.MaterialOrderSummary-delete-button {\n  background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%);\n  color: white;\n}\n\n.MaterialOrderSummary-delete-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.3);\n}\n\n/* Modal */\n.MaterialOrderSummary-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.MaterialOrderSummary-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.MaterialOrderSummary-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.MaterialOrderSummary-modal-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n.MaterialOrderSummary-close-button {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: color 0.2s ease;\n}\n\n.MaterialOrderSummary-close-button:hover {\n  color: #ef4444;\n}\n\n/* Form */\n.MaterialOrderSummary-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.MaterialOrderSummary-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.MaterialOrderSummary-form-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.MaterialOrderSummary-form-input {\n  padding: 12px 16px;\n  font-size: 14px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.MaterialOrderSummary-form-input:focus {\n  border-color: #3b82f6;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.MaterialOrderSummary-form-error {\n  color: #ef4444;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.MaterialOrderSummary-form-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.MaterialOrderSummary-submit-button {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  padding: 12px 30px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.MaterialOrderSummary-submit-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);\n}\n\n.MaterialOrderSummary-cancel-button {\n  background: #f1f5f9;\n  color: #64748b;\n  border: 2px solid #e2e8f0;\n  padding: 12px 30px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.MaterialOrderSummary-cancel-button:hover {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n/* No Data */\n.MaterialOrderSummary-no-data {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748b;\n  font-style: italic;\n  font-size: 16px;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .MaterialOrderSummary-container {\n    padding: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .MaterialOrderSummary-title {\n    font-size: 2rem;\n  }\n\n  .MaterialOrderSummary-table {\n    min-width: 600px;\n  }\n\n  .MaterialOrderSummary-form-actions {\n    flex-direction: column;\n  }\n\n  .MaterialOrderSummary-submit-button,\n  .MaterialOrderSummary-cancel-button {\n    width: 100%;\n  }\n}\n\n@media (max-width: 640px) {\n  .MaterialOrderSummary-container {\n    padding: 10px;\n  }\n\n  .MaterialOrderSummary-table-header,\n  .MaterialOrderSummary-table-cell {\n    padding: 12px 8px;\n    font-size: 12px;\n  }\n\n  .MaterialOrderSummary-action-button {\n    padding: 6px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .MaterialOrderSummary-container {\n    background: white;\n    box-shadow: none;\n  }\n\n  .MaterialOrderSummary-table-container {\n    box-shadow: none;\n    border: 1px solid #000;\n  }\n\n  .MaterialOrderSummary-table-header {\n    background: #f0f0f0 !important;\n    color: #000 !important;\n  }\n\n  .MaterialOrderSummary-action-button,\n  .MaterialOrderSummary-modal-overlay {\n    display: none;\n  }\n}\n\n.MaterialOrderSummary-table-header-action {\n  background: #ffffff !important;\n  color: #000 !important;\n  border-bottom: 2px solid #e2e8f0;\n}\n.MaterialOrderSummary_print_container {\n  display: flex;\n  justify-content: end;\n}\n.MaterialOrderSummary_print_container button {\n  padding: 10px 30px;\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  margin-bottom: 10px;\n  background: linear-gradient(135deg, #0d5787 0%, #91c8e4 100%);\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
